// @flow
import { connect } from 'react-redux';
import DeviceIcon from './component';
import { getIconLocaleSuffix } from '~/core/state/config/selectors';
import { iconForDevice } from '~/core/utils/devices';

const mapStateToProps = (state, { active, model, type }) => ({
    icon: iconForDevice({
        active,
        localeSuffix: getIconLocaleSuffix(state),
        model,
        type
    })
});

// $FlowFixMe
export default connect(mapStateToProps)(DeviceIcon);



// WEBPACK FOOTER //
// ./src/core/icons/device-icon/index.js